module.exports = __webpack_public_path__ + "static/img/banner_background_03.a56f0b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/banner_background_03.png
// module id = Uqgk
// module chunks = 0